/* eslint-disable camelcase */
/*
 * コンサル側 ホットライン相談申し込み 面談更新
 */
import { apiUpdate } from '@/actions/ApiBaseActions';
export const API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_SCHEDULE = 'API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_SCHEDULE';
export const API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_RESCHEDULE = 'API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_RESCHEDULE';
export const API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_CANCEL = 'API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_CANCEL';
export const API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_PHONE = 'API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_PHONE';
/**
 * コンサルタント：ホットライン相談申し込み面談 受諾
 */
export const apiUpdateProfessionalHotlineRequestInterviewSchedule = ({ json, path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_SCHEDULE, `/professional/hotline/${id}/request/${hotline_request_id}/schedule/${hotline_request_interview_id}`, json, meta);
/**
 * コンサルタント：ホットライン相談申し込み面談 再調整
 */
export const apiUpdateProfessionalHotlineRequestInterviewReschedule = ({ json, path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_RESCHEDULE, `/professional/hotline/${id}/request/${hotline_request_id}/reschedule/${hotline_request_interview_id}`, json, meta);
/**
 * コンサルタント：ホットライン相談申し込み面談 キャンセル
 */
export const apiUpdateProfessionalHotlineRequestInterviewCancel = ({ json, path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_CANCEL, `/professional/hotline/${id}/request/${hotline_request_id}/cancel/${hotline_request_interview_id}`, json, meta);
/**
 * コンサルタント：ホットライン相談申し込み面談 電話番号のみ更新
 */
export const apiUpdateProfessionalHotlineRequestInterviewPhone = ({ json, path: { hotline_request_id, hotline_request_interview_id, id } }, meta) => apiUpdate(API_UPDATE_PROFESSIONAL_HOTLINE_REQUEST_INTERVIEW_PHONE, `/professional/hotline/${id}/request/${hotline_request_id}/phone/${hotline_request_interview_id}`, json, meta);
